__turbopack_context__.v({
  "description": "DrawerModalAction-module-scss-module__OT3gAa__description",
  "icon": "DrawerModalAction-module-scss-module__OT3gAa__icon",
  "title": "DrawerModalAction-module-scss-module__OT3gAa__title",
});
